<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: 'app',
  mounted: function () {
    // nothing
  },
  methods: {
    // nothing
  }
}
</script>
<style>
  body .el-table th.gutter{
    display: table-cell!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue